import React from 'react'
import { Priority } from '../../constants'
import { prioritiesToAcademySearchLink } from '../../utils'
import {
  Container,
  CardsContainer,
  StyledCard,
  CardTag,
  CardTitle,
  CardDescription,
  LinkButton,
  ExploreLink,
} from './ImpactPlan.styled'

type Props = {
  priorities: Priority[]
}

export const ImpactPlan = ({ priorities }: Props) => {
  const cards = [
    {
      tag: `Matches with ${priorities[0]}`,
      title: "Let's Collaborate",
      description:
        "We'll build your confidence across all areas. Explore Coaching Hub for 1:1 sessions with experts or connect with changemakers in group sessions.",
      buttonText: 'Explore Coaching Hub',
      to: '/coaching',
    },
    {
      tag: `Matches with ${priorities[1]}`,
      title: 'Get A Boost',
      description:
        "You're ready to go but could use a little help. Launch our Goals Wizard to generate six goals based on your unique profile to get started.",
      buttonText: 'Launch Goals Wizard',
      to: '/impact/goals/wizard',
    },
    {
      tag: `Matches with ${priorities[2]}`,
      title: 'Confident Changemaker',
      description:
        "You're ready to take a deep dive into our large pool of resources. We've pulled together a few resources based on your selected priorities.",
      buttonText: 'View Recommended Resources',
      to: prioritiesToAcademySearchLink(priorities),
    },
  ]

  return (
    <Container>
      <CardsContainer>
        {cards.map((card) => (
          <StyledCard key={card.title} elevation={1}>
            <CardTag>{card.tag}</CardTag>
            <CardTitle>{card.title}</CardTitle>
            <CardDescription>{card.description}</CardDescription>
            <div>
              <LinkButton to={card.to}>{card.buttonText}</LinkButton>
            </div>
          </StyledCard>
        ))}
      </CardsContainer>

      <ExploreLink to='/'>Explore on my own</ExploreLink>
    </Container>
  )
}
